import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google"; // import here
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Help from "./pages/Help";
import Search from "./pages/Search";
import Discover from "./pages/Discover";
import Insights from "./pages/Insights";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import SettingsPage from "./pages/Settings";
import Share from "./pages/Share";
import ContactForm from "./pages/Contact";
import NotFound from "./pages/NotFound";
import { AuthProvider, useAuth } from "./context/AuthContext";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const ProtectedRoute = ({ children, pageTitle }) => {
  const { user } = useAuth();
  return user ? (
    <Layout pageTitle={pageTitle}>{children}</Layout>
  ) : (
    <Navigate to="/login" />
  );
};

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/about" element={<Layout pageTitle="About"><About /></Layout>} />
            <Route path="/blog" element={<Layout pageTitle="Blog"><Blog /></Layout>} />
            <Route path="/help" element={<Layout pageTitle="Help"><Help /></Layout>} />
            <Route path="/login" element={<Layout><Login /></Layout>} />
            <Route path="/register" element={<Layout><Register /></Layout>} />
            <Route path="/contact" element={<Layout><ContactForm /></Layout>} />

            {/* Protected routes */}
            <Route path="/settings" element={
              <ProtectedRoute pageTitle="Settings">
                <SettingsPage />
              </ProtectedRoute>
            } />
            <Route path="/search" element={
              <ProtectedRoute pageTitle="Search">
                <Search />
              </ProtectedRoute>
            } />
            <Route path="/share" element={
              <ProtectedRoute pageTitle="Share">
                <Share />
              </ProtectedRoute>
            } />
            <Route path="/discover" element={
              <ProtectedRoute pageTitle="Discover">
                <Discover />
              </ProtectedRoute>
            } />
            <Route path="/insights" element={
              <ProtectedRoute pageTitle="Insights">
                <Insights />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute pageTitle="Dashboard">
                <Dashboard />
              </ProtectedRoute>
            } />

            {/* Catch-all */}
            <Route path="*" element={<Layout><NotFound /></Layout>} />
          </Routes>
        </Router>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
